module.exports = __webpack_public_path__ + "static/media/flag_usa.aefba3fe.svg";